
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 3.538a1.358 1.358 0 1 1-1.358 1.358A1.364 1.364 0 0 1 8 3.538Zm1.422 8.586a.389.389 0 0 0 .388-.389l-.006-.758a.389.389 0 0 0-.389-.389h-.389V7.363a.389.389 0 0 0-.389-.39H6.578a.389.389 0 0 0-.388.39v.764c0 .215.174.39.388.39h.39v2.065h-.39a.389.389 0 0 0-.388.388v.765c0 .215.174.39.388.39h2.844Z",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 16 16\" fill=\"none\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 3.53785C8.74988 3.53785 9.35777 4.14574 9.35777 4.89562C9.35777 5.64549 8.74988 6.25339 8 6.25339C7.25012 6.25339 6.64223 5.64549 6.64223 4.89562C6.64572 4.14719 7.25157 3.54134 8 3.53785ZM9.42151 12.1243C9.63627 12.1243 9.81036 11.9502 9.81036 11.7355L9.80398 10.9769C9.80398 10.7621 9.62989 10.588 9.41514 10.588H9.02629V7.36255C9.02629 7.1478 8.8522 6.97371 8.63745 6.97371H6.57849C6.36373 6.97371 6.18964 7.1478 6.18964 7.36255V8.12749C6.18964 8.34224 6.36373 8.51633 6.57849 8.51633H6.96733V10.5817H6.57849C6.36373 10.5817 6.18964 10.7558 6.18964 10.9705V11.7355C6.18964 11.9502 6.36373 12.1243 6.57849 12.1243H9.42151Z\" fill=\"black\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/info-icon.e4ab109cc437b69cd2cae354f8c76301.svg"),
        {
          React: SvgInfoIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      